import axiosClient from '../interceptors';
import { ApiRoutes } from '../routes/ApiRoutes';
import { getAPIUrl } from './BaseService';
import { SubjectTagOut } from '../types';

const SUBJECT_TAGS_ROUTE = `${getAPIUrl()}${ApiRoutes.SUBJECT_TAGS}`;

/**
 * Fetch distinct subject tags. If `classroomId` is omitted the BE returns
 * tags across the caller's school; otherwise scoped to that classroom.
 */
export async function listSubjectTags(
    classroomId?: string | null,
): Promise<SubjectTagOut[]> {
    const response = await axiosClient.get<SubjectTagOut[]>(SUBJECT_TAGS_ROUTE, {
        params: classroomId ? { classroom_id: classroomId } : undefined,
    });
    return response.data;
}
